import { render, staticRenderFns } from "./OrderFiles.vue?vue&type=template&id=25c50ee4&scoped=true&"
import script from "./OrderFiles.vue?vue&type=script&lang=js&"
export * from "./OrderFiles.vue?vue&type=script&lang=js&"
import style0 from "./OrderFiles.vue?vue&type=style&index=0&id=25c50ee4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c50ee4",
  null
  
)

export default component.exports